<template>
  <main class="main main--messaging main--full-height">
    <div class="appointments messaging group--wide messaging--messagessidebar"> 
      <div class="conversation-list">
        <h2 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h2 list-provider__title">Your Messages</h2>
        <div class="conversations">
          <a class="current-conversation" v-for="item in providerList" :key="item.id" >
            <div
              :style="getActivecssstyle(item.id, org)"
              :class ="[selectedId && item.id === selectedId ? 'conversation-preview active' : 'conversation-preview', item.unread_messages ? 'conversation-unread' : 'conversation-read']"
              @click="handleClick(item, item.id, item.provider.fullname)">
              <div class="conversation-preview-thumb-wrapper"><span>{{ displayName(item.provider.fullname) }}</span></div>
              <div class="conversation-preview-body">
                <p class="conversation-preview-body-title">
                  <span>{{ item.provider.fullname }}</span>
                <span class="c-specialty conversation-preview-time">{{ formatTime(item.last_message_at) }}</span></p>
                <p class="conversation-preview-body-subject"> {{ item.recent_message_subject }}</p>
                <p class="conversation-preview-body-text"> {{ item.recent_message_body }}</p>  
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="appointments__content chat">
        <div class="defaultmessage" style="text-align: left; padding-left: 30px" v-if="isLoading">Loading...</div>
        <div v-for="item in selectedItem" :key="item.id">
          <div class="table__column conversation" v-if="item.id">
            <div class="conversation-right-header">
              <p 
                :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                class="h2 list-provider__title">{{ item.provider.provider_card.full_name_with_affixes }}</p>
              <p class="conversation-preview-body-subject c-black"> {{ item.recent_message_subject }}</p>
            </div>
          </div>
        </div>
        <div class="default-window" v-if="selectedId">
          <div class="chat-window">
            <div class="right-left">
              <div v-for="message in apiResponse" :key="message.id">
                <div :class="{'chat-right-wind float-right':message.isUser, 'chat-right-wind':message.from}">
                  <div class = "chatmsg c-mid fw-bold">{{ message.isUser ? localUserdata : message.from }}
                    <span class="chatmsgtime c-mid">{{ formatTime(message.isUser ? message.date_time :message.date_time) }}</span>
                  </div>
                  <div 
                    :style="getCssstyle(message.isUser, org)"
                    :class="{ 'user-message': message.from, 'bot-message': message.isUser }">
                  <p v-html="message.message"/></div>
                </div>
              </div>
            </div>
          </div>
          <div class="input-area" v-if="reply(apiResponse)">
            <div class="large-12 medium-12 small-12 cell">
              <label for="select-files" class="attachment" :style="{ 'background-color': org.custom_color1 == null ? '': org.custom_color1}">
                <img 
                  :src="attachment_icon" 
                  alt="Attachment_icon" >
                <input id="select-files" type="file" @change="handleFilesUpload( $event )" @click="!isFile ? handleFileOnClick( $event ): sendMessage()">
              </label>
            </div>
            <input 
              ref="messageInput"
              class="con-input"
              v-model="inputmessage"
              @keydown="handleKeyDown"
              placeholder="Type your message...">
            <button 
              :style="{ 'background-color': org.custom_color1 == null ? '': org.custom_color1}"
              class="conver-btn" 
              :disabled="!inputmessage && !isFile"
              @click.prevent="sendMessage()">Reply</button>
          </div>
          <!-- attachmemnt file -->
          <div class="container">
            <div class="deleteicon">
              <div 
                v-for="(file, key) in files" 
                :key="'file-'+key"
                class="file-listing"><span class="filename">{{ file.name }} </span><span class="remove-file" @click="removeFile()"><img 
                  :src="delete_icon" 
                  alt="Delete_icon" ></span>
              </div>
            </div>
          </div>
          <!-- attachment end -->
        </div>
        <div class="defaultmessage" v-if="providerList.length <= 0 && !isLoading ">You have not received a message from any counselors yet.</div>
        <p class="errormsg" v-if="errorMsg">{{ errorMsg }}</p>
        <p v-if="!selectedId && providerList.length > 0" class="centered-message">No Conversation Selected</p>
        <p v-if="!selectedId && providerList.length > 0" class="fine-message">Select a conversation to read.</p>
      </div>
  </div></main>
</template>


<script>
import moment from 'moment';
import config from 'config';
import ModuleDots from 'components/Dots';

// Vuex

import { mapGetters, mapActions } from 'vuex';
import attachment_icon from 'images/icons/attachment_icon.svg';
import delete_icon from 'images/icons/delete_icon.svg';


export default {
  name: 'conversation',

  components: {
    ModuleDots,
  },

  data() {
    return {
      inputmessage: '',
      files: [],
      isFile : false,
      attachment_icon,
      delete_icon, 
      file:[],
      messages: [],
      userMessage: '',
      localUserdata: JSON.parse(localStorage.getItem('updateUser')).first_name || '',
      localTime: new Date(),
      event: Event,
      apiResponse: [],
      selectedId: '',
      enableChat: '',
      errorMsg : '',
      selectedItem: [],
      isLoading: true,
    };
  },

  
  computed: {
    ...mapGetters('app', ['org']),
    ...mapGetters('messaging', ['providerList']),
    ...mapGetters('auth', ['isAuthenticated']),
  },

  methods: {
    
    ...mapActions('messaging', ['markAsRead', 'fetchProviderList']),

    handleKeyDown(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        this.sendMessage();
      }
    },


    handleClick(item, id, fullname) {
      this.selectedItem=[];
      this.selectedItem.push(item);
      this.getData(id, fullname);
      if (item && item.unread_messages && item.unread_messages > 0){
        this.markAsReadApi(id);
      }
    },

    displayName(fullname) {
      if (!fullname) return '';
      const names = fullname.split(' ');
      const firstNameInitial = names[0] ? names[0][0] : '';
      const lastNameInitial = names[1] ? names[1][0] : '';
      return `${firstNameInitial}${lastNameInitial}`;
    },

    formatTime(time) {
      return moment(time).format('MM/DD/YYYY h:mma');
    },

    markAsReadApi(id) {
      const model = {
        id,
      };
      this.markAsRead(model);
    },

    reply(messages){
      const userId = JSON.parse(localStorage.getItem('updateUser')).mdlive_id;
      const nonUsermsg = messages.filter( msg => msg.from_id !== userId).reverse();
      return nonUsermsg.length && nonUsermsg[0].reply_allowed;
    },
    
    getCssstyle(isUser, org) {
      if(isUser) {
        return { 'background-color': org.custom_color1 === null ? '': org.custom_color1, 'color': org.custom_color2 === null ? '': '#FFFFFF' };
      } 
      return { 'background-color': org.custom_color2 === null ? '': org.custom_color2, 'color': org.custom_color3 === null ? '': org.custom_color3 };
    },
    getActivecssstyle(id, org) {
      if(id === this.selectedId ){
        return { 'background-color': org.custom_color1 === null ? '': org.custom_color1, 'color': org.custom_color2 === null ? '': '#FFFFFF' };
      } 
      return { 'background-color': org.custom_color2 === null ? '': org.custom_color2, 'color': org.custom_color3 === null ? '': org.custom_color3 };
    },


    submitFiles(){

      this.isFile = false;

      const formData = new FormData();
      const mdLiveApi = config.mdLiveApi;
      const userId = JSON.parse(localStorage.getItem('updateUser')).mdlive_id;
 
      const file = this.files;

      formData.append('files', file[0]);

      const fileInput = document.querySelector('#select-files');

      const data = fileInput.files[0];
      const type = data.type;

      const reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onload =  () => {
        const base64File = reader.result.split('base64,')[1];
        const doc = {
          document_name: data.name,
          mime_type:type,
          record_type:'Patient Record',
          data: base64File,
        };

        fetch(`${mdLiveApi}/v2/patients/${userId}/documents`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('mdLiveAuthToken')}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ doc }),
        })
          .then(response => {
            if(response.status === 200 || response.status === 201){
              const addComment = {
                dock_health_task_id:'',
                id:'',
                last_message_at:'',
                last_message_by:'',
                provider:{},
                message:this.files.length > 0 ? `${this.inputmessage ? this.inputmessage : 'File uploaded to Patient Record:<br/>'} ${this.files[0].name}` : this.inputmessage,
                recent_message_subject:'',
                isUser: true,
                from_id: JSON.parse(localStorage.getItem('updateUser')).mdlive_id,
              };
              this.apiResponse.push(addComment);
              this.postMessageToApi(this.inputmessage);
              this.file = [];
              this.files = [];
              this.inputmessage = '';
              
            }
            else {
              this.errorMsg ='Something went wrong';
              setTimeout(()=> {
                this.errorMsg = '';
              },5000);
            }
          })
          .catch(error => {
            console.error('Error:', error);
          });
      };
      
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };

    },
    /*
        Handles the uploading of files
      */
    handleFilesUpload( event ){
      const uploadedFiles = event.target.files;
      if (uploadedFiles.length === 0) {
        this.files=[];
        this.isFile=false;
        return;
      }
      if(this.isFile && this.files.length > 0){
        this.files = [];
        this.isFile=false;
      }
      this.files.push( uploadedFiles[0] );
      this.isFile = true;
      this.$nextTick(() => {
        this.$refs.messageInput.focus();
      });
    },

    handleFileOnClick( event ){
      event.target.value = '';
    },
    /*
        Removes a select file the user has uploaded
      */
    removeFile(){
      this.files = [];
      this.isFile=false;
    },

    //
   
    async sendMessage() {
      if (this.inputmessage.trim() === '' && !this.isFile) {
        return;
      }
      if(this.files.length > 0){
        this.submitFiles();
        return;
      }
      const addComment = {
        dock_health_task_id:'',
        id:'',
        last_message_at:'',
        last_message_by:'',
        provider:{},
        message:this.files.length > 0 ? `${this.inputmessage ? this.inputmessage : 'File uploaded to Patient Record:<br/>'} ${this.files[0].name}` : this.inputmessage,
        recent_message_subject:'',
        isUser: true,
        from_id: JSON.parse(localStorage.getItem('updateUser')).mdlive_id,
      };
      this.apiResponse.push(addComment);
      this.postMessageToApi(this.inputmessage);
      this.file = [];
      this.files = [];
      this.isFile=false;
      this.inputmessage = '';
    },

    
    async postMessageToApi() {

      const chatPaload = { message: this.files.length > 0 ? `${this.inputmessage ? this.inputmessage : 'File uploaded to Patient Record:<br/>'} ${this.files[0].name}`: this.inputmessage };
    
      this.inputmessage = '';
      try {
        const mdLiveApi = config.mdLiveApi;
        const userId = JSON.parse(localStorage.getItem('updateUser')).mdlive_id;
        const response = await fetch(`${mdLiveApi}/v2/patients/${userId}/conversations/${this.selectedId}/reply`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('mdLiveAuthToken')}`,
            'Content-Type': 'application/json',
          },
          body:JSON.stringify(chatPaload),
        });  
        if(!(response.status === 200 || response.status === 201 || response.status === 301) ){
          this.errorMsg ='Sorry, There was an error';
          this.apiResponse.pop();
          setTimeout(()=> {
            this.errorMsg = '';
          },5000);
        }
        
      }
      catch (error) {
        console.error( 'Error posting message to API:', error);
        return { text: 'Sorry, There was an error' };
      }
    },

    async getData(id) {
      this.selectedId = id;
      this.enableChat = '';
      try {
        const apiurl = config.api;
        const userId = JSON.parse(localStorage.getItem('updateUser')).mdlive_id;
        this.loading = true;
        const response = await
        fetch(`${apiurl}messages/user/${userId}/conversation/${id}/messages`);
        if(response.ok) {
          const data = await response.json();
          this.apiResponse = data.messages.reverse();
          this.apiResponse.forEach(ele => {
            ele.isUser = ele.from_id === userId;
          });
          this.enableChat = this.apiResponse.slice(-1);
        } else {
          console.error('Failed to fetch Data');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.loading = false;
      }
    },
  },

  async mounted() {
    this.isLoading = true;
    try {
      if(this.isAuthenticated){
        await this.fetchProviderList();
      }
    } catch (error) {
      console.error('Error fetching provider list:', error);
    } finally {
      this.isLoading = false;
    }
  },

  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: 'home' });
    }
  },
};
</script>
<style scoped>
.centered-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10vh; 
  text-align: left;
  font-size: 1.2em;
  font-weight: 550;
}
.fine-message {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 5vh; 
  text-align: left;
  font-size: 0.8em; 
}
  input[type="file"]{
    position: absolute;
    top: -500px;
  }

  span.remove-file{
    color: red;
    cursor: pointer;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// Conversation.vue?7188a2d2